import { render, staticRenderFns } from "./workList.vue?vue&type=template&id=2417f70f&scoped=true&lang=html&"
import script from "./workList.vue?vue&type=script&lang=js&"
export * from "./workList.vue?vue&type=script&lang=js&"
import style0 from "./workList.vue?vue&type=style&index=0&id=2417f70f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2417f70f",
  null
  
)

export default component.exports